import React, { useState, useEffect, useContext, Component, useRef } from "react";
import "./login.css";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
//import Buttons from "../../toolkit/ButtonV1";
// import Carousel from '../../reusable-components/carousel/Carousel';
import Carousel from "../../reusable-components/carousel/Carousel";
import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import HelpIcon from "@mui/icons-material/Help";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import Img from "../../Media/workerImage.png"
import axios from "../../utils/fvAxios";

import Select from "@mui/material/Select";
import Footer from "../../reusable-components/footer/footer";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import BaseUrl from "../../utils/base-uri.json";
import MuiAlert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { Stack, Typography, Box } from "@mui/material";

import { useTranslation } from "react-i18next";
import "../../Localization/i18n";
import i18n from "i18next";

import changeLocale from "../../Localization/changeLocale";
import LocaleContext from "../../Localization/LocaleContext";

import {
  setToken, setEmail, setUserName, setGlobalClientId, setstatuses, setOrgType, setLocalMenus, removeIncognitoEmail, setOrgId, setisEmp, getisEmp, getExpiredSec,
  getInvitationURL, getInvitationVendorId, getInvitationClientId, getInvitationIsMultiClient, getInvitationPqid, setOnSiteOffsiteDetails, setOnSiteOffsiteId, setExpiredSec,
  setMoodleUserId
} from "../../utils/Token";
import main from "../../Media/MainLogo.png";
import apiinfo from "../../utils/base-uri.json";
import Loginhelp from "../loginhelp/Loginhelp";

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LoginVerification from "./LoginVerification";
import LoginEmailVerification from "./LoginEmailVerification";
import CryptoJS from "crypto-js";


function Login({ ...props }) {
  const params = new URLSearchParams(window.location.search);
  const isRegistered = params.get("registered");
  if (isRegistered === "success") {
    window.history.pushState({}, "", "/");
    toast.success("Registration Succesfull", {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }

  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const [tokenValue, setTokenValue] = React.useState("");
  const [carouselFlag, setCarouselFlag] = React.useState(false);
  const [loginLanguage, setLoginLanguage] = React.useState(props.content);
  const [phoneNumberCode, setPhoneNumberCode] = React.useState("us");
  const [openError, setOpenError] = React.useState(false);
  const [error, setError] = React.useState(null);


  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });
  const { t } = useTranslation();
  const { locale } = useContext(LocaleContext);

  function changeLocale() {
    if (i18n.language == "en")
      i18n.changeLanguage("ar");
    else
      i18n.changeLanguage("en");

  }
  const ChangeL = () => {
    changeLocale();
  };

  // const validationSchema = Yup.object().shape({
  //   userName: Yup.string()
  //     .required("User name is required !")
  //     .max(200, "User name must not exceed 200 characters"),
  //   password: Yup.string().required("Password is required !"),
  // });
  // const {
  //   register,
  //   handleSubmit,
  //   formState: { errors },
  // } = useForm({ resolver: yupResolver(validationSchema) });

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpenError(false);
    setOpen(false);
  };



  // const handlePhoneCheck = (val) => {
  //   setPhoneNumberCode(val);
  // };
  const [UserName, setUsername] = React.useState("");
  const [UserNameErr, setUserNameErr] = React.useState("");
  const [Password, setPassword] = React.useState("");
  const [PasswordErr, setPasswordErr] = React.useState(false);
  const [RememberMe, setRememberMe] = useState(false);


  const ChangeUserName = (e) => {
    if (e == "") {
      setUserNameErr("User name is required !");
      setUsername(e);
    } else if (e.length > 200) {
      setUserNameErr("User name must not exceed 200 characters");
      setUsername(e);
    }
    else {
      setUserNameErr("");
      setUsername(e);
    }

  }
  const ChangePassword = (e) => {
    if (e == "") {
      setPasswordErr("Password is required !");
      setPassword(e);
    } else {
      setPasswordErr("");
      setPassword(e);
    }

  }

  useEffect(() => {
    localStorage.removeItem("ValidUser");
    localStorage.removeItem("ValidPass");
    const keyDownHandler = e => {
      if (e.key === 'Enter') {
        e.preventDefault();
        SentVerificationCode();
        //onSubmit();
      }
    };
    document.addEventListener('keydown', keyDownHandler);
    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };

  }, [UserName, Password, RememberMe]);


  const SentVerificationCode = () => {
    setSpinner(true);
    const details = {
      "userName": UserName,
      "password": Password
    }

    localStorage.setItem("ValidUser", UserName);
    localStorage.setItem("ValidPass", Password);

    axios.post("Login/CheckUserLoginValidity", details)
      .then((res) => {
        if (res?.data?.responseCode == 100) {
          if (res?.data?.responseMessage == "User already authenticated") {
            onSubmit();
          } else if (res?.data?.responseMessage == "Success") {
            navigate("/LoginVerification?RememberMe=" + RememberMe);
          }
        } else if (res?.data?.responseMessage == "Redirect to the dashboard screen") {   // newoly Added
          onSubmit();
        } else if (res?.data?.responseMessage == "Redirect to the captcha screen") {   // newoly Added
          navigate("/LoginVerification?RememberMe=" + RememberMe + "&isSelected=1");
        } else if (res?.data?.responseCode == -100) {
          if (res?.data?.responseMessage == "Email not found") {
            navigate("/LoginEmailVerification?RememberMe=" + RememberMe);
          } else if (res?.data?.responseMessage == "Invalid credentials") {
            toast.error(res?.data?.responseMessage, {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          } else if (res?.data?.responseMessage == "Invalid Email" || res?.data?.responseMessage == "Invalid email") {
            navigate("/LoginEmailVerification?RememberMe=" + RememberMe);
            // navigate("/LoginEmailVerification?UserName=" + UserName + "&RememberMe=" + RememberMe + "&Password=" + urlSafeEncrypted);
          } else if (res?.data?.responseMessage == "You do not have enough privileges to access the system. Please contact system administrator") {
            toast.error(res?.data?.responseMessage, {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          }
        } else {
          toast.error(res?.data?.responseMessage, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
        setTimeout(() => {
          setSpinner(false);
        }, 5000)
      })
  }
  const onSubmit = () => {
    setSpinner(true);
    const details = {
      "userName": UserName,
      "password": Password
    }
    axios
      .post(BaseUrl.login.loginRequest, details)
      .then((response) => {
        if (response?.data?.responseCode >= 0) {
          setExpiredSec("0");
          removeIncognitoEmail();
          setToken(response?.data?.data?.token);
          setUserName(response?.data?.data?.userName);
          setEmail(response?.data?.data?.email);
          setGlobalClientId(response?.data?.data?.globalClientId);
          setOrgId(response?.data?.data?.orgId);
          setOrgType(response?.data?.data?.orgType);
          setLocalMenus(response?.data?.data?.userMenus);
          setisEmp(response?.data?.data?.isEmployee);
          setMoodleUserId(response?.data?.data?.moodleUserId);

          //RememberMe New Function
          if (RememberMe) {
            localStorage.setItem("username", UserName);
            localStorage.setItem("password", Password);
            localStorage.setItem("rememberMe", "true");
          } else {
            const savedUser = localStorage.getItem("username");
            if (savedUser === UserName) {
              localStorage.removeItem("username");
              localStorage.removeItem("password");
              localStorage.removeItem("rememberMe");
            }
          }
          //

          axios.get(apiinfo.dashboard.GetprequalificationStatuses)
            .then((res) => {
              if (res?.data?.status === true) {
                setstatuses(res?.data?.data);
              } else {
                alert(res.data.responseMessage);
              }
            })

          axios.get(BaseUrl.login.getAnnouncement)
            .then((response) =>
              response.data.headers > 0
                ? setCarouselFlag(true)
                : setCarouselFlag(false)
            );

          const URL = getInvitationURL();
          const VendorId = getInvitationVendorId();
          const CLIENTID = getInvitationClientId();
          const ISMultiClient = getInvitationIsMultiClient();
          const InvitationPqid = getInvitationPqid();

          const allowedPath = ["/registration-company"];
          const PageName = (!URL || URL == "null" || URL == "/login?registered=success") ? (!(response?.data?.data?.isEmployee) || response?.data?.data?.isEmployee == false ? "/DashBoard" : "/EmployeeSignature") : ((URL && VendorId != 'null' && URL?.indexOf(allowedPath) !== -1) ? "/DashBoard" : (URL == "/TemplatesList" ? (URL + "?InvitationClient=" + CLIENTID + "&InvitationVendor=" + VendorId + "&InvitationIsMultiClient=" + ISMultiClient + "&pqid=" + InvitationPqid) : URL));
          navigate(PageName);
          localStorage.removeItem("ValidUser");
          localStorage.removeItem("ValidPass");
          //navigate(response?.data?.data?.userMenus[0]?.actionName)
        } else {
          setSpinner(false);
          toast.error(response.data.responseMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }

      });

  };

  const [img, setimg] = React.useState('');
  const [Trgimg, setTrgimg] = React.useState(false);

  useEffect(() => {
    const savedUsername = localStorage.getItem("username");
    const savedPassword = localStorage.getItem("password");
    const savedCheck = localStorage.getItem("rememberMe");

    if (savedCheck === "true" && savedUsername && savedPassword) {
      setUsername(savedUsername);
      setPassword(savedPassword);
      setRememberMe(true);
    }

    setTrgimg(true);
    axios.get("Login/GetLoginImageBasedOnCurrentDate")
      .then((res) => {
        if (res?.data?.status === true) {
          setimg(res?.data?.data?.url);
          setTrgimg(false);
        } else {
          setimg('');
          setTrgimg(false);
        }
      })
  }, []);

  const [values, setValues] = React.useState({
    password: '',
    showPassword: false,
  });
  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const [spinner, setSpinner] = React.useState(false);
  const SpinnerClose = () => {
    setSpinner(false);
  };
  // const handleToggle = () => {
  //   setSpinner(!open);
  // };



  return (
    <>
      <ToastContainer />
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={spinner}
        onClick={SpinnerClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div id="login" className="first-verify__loginContainer">
        <div className="first-verify__leftContainer">
          <div className="first-verify__logo"></div>
          <div className="first-verify__loginSubContainer">
            <span className="first-verify__loginHeading padding-top-10">
              {props.content.loginPage.loginHeading.Heading1}
            </span>
            <span className="first-verify__loginSubheading padding-top-10">
              {props.content.loginPage.loginHeading.Heading2}
            </span>
            <div className="first-verify__logindetails">
              <span className="text-danger" style={{ fontWeight: "bold" }} hidden={getExpiredSec() != 1}>Session Expired!! Please login again.</span>

              <span className="username-label padding-top-10">
                {props.content.loginPage.inputLabel.userName}
              </span>
              <TextField
                id="outlined-basic"
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                inputProps={{ className: "login-user" }}
                // error={errors.firstName ? true : false}
                // {...register("userName")}
                value={UserName}
                onChange={(e) => ChangeUserName(e.target.value)}
                placeholder={props.content.loginPage.userIdPlaceholder}
                variant="outlined"
                required
              />
              <Typography className="asterisk-red">
                {UserNameErr}
              </Typography>
              <span className="password-label">
                {props.content.loginPage.inputLabel.password}
              </span>
              <FormControl sx={{ width: '378px' }} variant="outlined">
                <OutlinedInput
                  id="outlined-basic"
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  type={values.showPassword ? 'text' : 'password'}
                  inputProps={{ className: "login-password" }}
                  // error={errors.firstName ? true : false}
                  // {...register("password")}
                  value={Password}
                  onChange={(e) => ChangePassword(e.target.value)}
                  placeholder={props.content.loginPage.passwordPlaceholder}
                  variant="outlined"
                  required
                  endAdornment={
                    <InputAdornment position="end" sx={{
                      '&$focused $notchedOutline': {
                        borderColor: '#2EFF22',
                        borderWidth: 1,
                      },
                    }}>
                      <IconButton
                        id="outlined-basic"
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {values.showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
              <Typography className="asterisk-red">
                {PasswordErr}
              </Typography>
            </div>
            <div className="first-verify__logindetails padding-top-0">
              <FormControlLabel
                sx={{ marginLeft: "unset" }}
                control={<Checkbox
                  checked={RememberMe}
                  onChange={(e) => setRememberMe(e?.target?.checked)}
                />}
                label={props.content.loginPage.inputSubOptions.rememberme}
              />
              <Button
                variant="text"
                className="button-forgetPassword"
                sx={{ color: "#2A93DB", fontWeight: 500, textTransform: "capitalize" }}
                onClick={() => navigate("/forgot-password")}
              >
                {props.content.loginPage.inputSubOptions.forgetPassword}
              </Button>
              {/* <Button
                
                 variant="contained"
                sx={{ color: "#2A93DB", fontWeight: 500, textTransform: "capitalize" }}
                onClick={changeLocale}
              >
                Language
              </Button> */}
            </div>
            <div className="first-verify__logindetails padding-top-0">
              <Button
                sx={{ padding: "15px", textTransform: "capitalize" }}
                variant="contained"
                role="primary"
                className="login-button"
                onClick={SentVerificationCode}
              //onClick={onSubmit}
              >
                {props.content.loginPage.inputSubOptions.loginbutton}
              </Button>
            </div>



            <div className="first-verify__logindetails padding-top-10 text-align-center">
              {props.content.loginPage.subLabels.noaccount}
              <Button
                variant="text"
                sx={{ color: "#2A93DB", fontWeight: 500, textTransform: "capitalize" }}
                onClick={() => navigate("/registration-option")}
              >
                {props.content.loginPage.subLabels.signup}
              </Button>
            </div>

            <div className="first-verify__logindetails padding-top-10 text-align-center">
              <Button
                variant="text"
                sx={{
                  backgroundColor: "#EFF8FF",
                  color: "#2A93DB",
                  fontWeight: 500,
                  textTransform: "capitalize"
                }}
                onClick={handleClickOpen}
              >
                <HelpIcon color="primary" fontSize="small" />
                {props.content.loginPage.subLabels.loginHelp}
              </Button>
              <Button
                variant="text"
                className="mx-2"
                sx={{
                  backgroundColor: "#EFF8FF",
                  color: "#2A93DB",
                  fontWeight: 500,
                  textTransform: "capitalize",
                  padding: "12px"
                }}
                onClick={() => navigate("/Lookupusername")}
              >
                {"Look Up Trainee Username"}
              </Button>
              <Dialog open={open} onClose={handleClose}>
                <DialogTitle
                  sx={{
                    textAlign: "center",
                    fontWeight: 600,
                    marginTop: 3,
                    fontSize: 20,
                  }}
                >
                  Login Help
                </DialogTitle>
                <IconButton
                  aria-label="close"
                  onClick={handleClose}
                  sx={{
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  <span className="red-color"><CloseIcon /></span>
                </IconButton>


                <Loginhelp close={handleClose} />
              </Dialog>
            </div>
          </div>
          <Footer />
        </div>
        {/* <div className="first-verify__rightContainer">
          <div className="first-verify__rightSubContainer" style={{ backgroundImage: img }}>
            <div className="first-verify__carousel-container">
              <Carousel displayFlag={carouselFlag} />

            </div>
          </div>


        </div> */}
        <div className="first-verify__rightContainer">
          {Trgimg
            ?
            <div className="loader-container">
              <CircularProgress color="inherit" sx={{ color: "#fff" }} />
            </div>
            :
            <div
              className="first-verify__rightSubContainer"
              style={{
                backgroundImage: img ? `url(${img})` : `url(${main})`,
              }}
            >
              <div className="first-verify__carousel-container">
                <Carousel displayFlag={carouselFlag} />
              </div>
            </div>
          }
        </div>
      </div>

      {/*-------Verification code---*/}
      {/* <div id="verify" className="first-verify__loginContainer">
        <div >
          <div className='first-verify__logo'></div>
          <div className='first-verify__loginSubContainer'>
            <div id="verificationcode" className="first-verify__forgetPasswordContainer">
              <div className="first-verify__logoContaineremailverification"></div>
              <span className='first-verify__loginHeading'>{"Enter your verification code"}</span>
              <span className='first-verify__loginSubheading'>
                {"We have sent a verification code to "}{NewEmail == "" ? UserName : NewEmail}
              </span>
              <div className='first-verify__logindetails' style={{ paddingTop: "0px" }}>
                <Box display="flex" justifyContent="center" gap={1.5}>
                  {otp.map((digit, index) => (
                    <TextField
                      key={index}
                      inputRef={(el) => (inputRefs.current[index] = el)}
                      value={digit}
                      onChange={(e) => handleChange(e, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      inputProps={{
                        maxLength: 1,
                        style: {
                          textAlign: "center",
                          fontSize: "20px",
                          width: "45px",
                          height: "45px",
                        },
                      }}
                      variant="outlined"
                    />
                  ))}
                </Box>
              </div>
              <div className='first-verify__logindetails padding-top-0 text-align-center'>
                <Button variant="contained" className={otp.every((val) => val !== "") ? "login-button" : "login-button1"}
                  sx={{ textTransform: "capitalize", padding: "15px" }} disabled={otp.every((val) => val !== "") ? false : true}
                  onClick={VerifyCode} >{"Verify Code"}</Button>
                <Stack direction={"row"} spacing={3}>
                  <span className="mt-2" style={{ color: "#94979f" }}>
                    Didn’t receive the code?
                  </span>
                  <div
                    className="mt-2"
                    variant="contained"
                    style={{
                      textTransform: "capitalize",
                      color: "#2A93DB",
                      marginLeft: "90px",
                      cursor: "pointer",
                    }}
                    onClick={ResendCode}
                  >
                    Resend Code
                  </div>
                </Stack>

                <Button variant="outlined" className="login-button-backtologin"
                  onClick={() => {
                    document.getElementById("login").classList.remove("hideDiv");
                    document.getElementById("verify").classList.add("hideDiv");
                    document.getElementById("wrongusername").classList.add("hideDiv");
                  }}><ArrowBackIcon />{"Back"}</Button>
              </div>
            </div>

            <div id="wrongusername" className="first-verify__forgetPasswordContainer">
              <div className="first-verify__logoContaineremailverification"></div>
              <span className='first-verify__loginHeading'>{"Enter your email"}</span>
              <span className='first-verify__loginSubheading'>
                {"Email does not exist, please provide your email to proceed."}
              </span>
              <div className='first-verify__logindetails'>
                <span className='password-label'>{props.content.setPassword.email}</span>
                <TextField sx={{
                  '& legend': { display: 'none' },
                  '& fieldset': { top: 0 },
                }} id="outlined-basic" placeholder={props.content.setPassword.enterEmailPlaceholder} value={NewEmail} onChange={e => setNewEmail(e.target.value)} inputProps={{ className: "login-password" }} variant="outlined" />
              </div>
              <div className='first-verify__logindetails padding-top-0 text-align-center'>
                <Button variant="contained" className="login-button" sx={{ textTransform: "capitalize", padding: "15px" }} onClick={UpdateEmail} >{"Send code"}</Button>
                <Button variant="outlined" className="login-button-backtologin"
                  onClick={() => {
                    document.getElementById("login").classList.remove("hideDiv");
                    document.getElementById("verify").classList.add("hideDiv");
                    document.getElementById("wrongusername").classList.add("hideDiv");
                  }}><ArrowBackIcon />{"Back"}</Button>
              </div>
            </div>

          </div>
          <Footer />
        </div>
      </div> */}

      {/*-------Verification code---*/}

    </>
  );
}
export default Login;
